import { Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import NotFound from "./Pages/NotFound";
import Home from "./Pages/Home";
import Navbar from "./Components/Navbar";
import PrivateRoutes from "./Components/PrivateRoutes";

function Layout() {
   return (
      <>
         <Navbar />
         <Routes>
            <Route element={<PrivateRoutes />} >
               <Route path="/home" element={<Home />} />
               <Route path="/*" element={<NotFound />} />
            </Route>
         </Routes>
      </>
   );
}

function App() {
   return (
      <Routes>
         <Route path="/" element={<Login />} />
         <Route path="/*" element={<Layout />} />
      </Routes>
   );
}

export default App;
